import { useEffect, useReducer } from 'react';

import { actions, homepageReducer, initialState } from '../Store';
import { getMyBoxDetails } from '../../../services/homepage';
import { getMyBoxRate } from '../../../services/boxRate';

const { setMyBox, setMyBoxSuccess, setMyBoxFail } = actions;

const useMyBox = () => {
  const [{ myBox }, stateDispatch] = useReducer(homepageReducer, initialState());

  useEffect(() => {
    stateDispatch(setMyBox());
    getMyBoxDetails()
      .then((data) => {
        getMyBoxRate().then((rateData) => {
          stateDispatch(setMyBoxSuccess({
            ...data,
            surveyFinished: rateData.surveyFinished,
            surveyStarted: rateData.surveyStarted,
            eligible: rateData.eligible,
          }));
        })
          .catch(() => stateDispatch(
            setMyBoxSuccess({
              ...data,
              surveyStarted: false,
              surveyFinished: true,
              eligible: false,
            }),
          ));
      })
      .catch((error) => stateDispatch(setMyBoxFail(error)));
  }, []);

  return myBox;
};

export default useMyBox;
